import React from "react";
import PropTypes from "prop-types";
import { PlusCircle } from "react-feather";
import i18next from "i18next";

const AdditionCard = ({ onClick }) => {
    return (
        <div className="addon-card extra-card" onClick={onClick}>
            <PlusCircle className="text-brand-primary-base" />
            <div className="content">
                <span className="title">
                    {i18next.t("basicIngredients.addition.title")}
                </span>
                <p
                    className="text"
                    dangerouslySetInnerHTML={{
                        __html: i18next.t("basicIngredients.addition.text"),
                    }}
                />
            </div>
        </div>
    );
};

AdditionCard.propTypes = {
    onClick: PropTypes.func,
};

export default AdditionCard;
